import React from 'react'
import styled from 'styled-components'
import { color } from '../styles'
import { SPACING, BORDER_RADIUS_LG } from '../styles/mixins/constants'
import { text } from '../styles/mixins/text'
import { Icon } from './Icon/index'
import { Spacer } from './Spacer'

type Props = {
    onClear?: (key: string) => void
    tagKey: string
    label: string | JSX.Element
    className?: string
}

export const Tag = (props: Props): JSX.Element => {
    const { tagKey, label, className, onClear } = props

    return (
        <Container className={className}>
            <Title>{label}</Title>
            {onClear && (
                <>
                    <Spacer size={2} />
                    <Icon
                        testingSelectors={['TagClear']}
                        iconKey="Clear"
                        size={2}
                        onClick={() => onClear(tagKey)}
                        color="primary"
                        activeColor="activity"
                    />
                </>
            )}
        </Container>
    )
}

const Container = styled.div`
    background-color: ${color.background.app};
    border: 1px solid ${color.border.primary};
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding: ${SPACING[2]};
    border-radius: ${BORDER_RADIUS_LG};
    flex: 0 1 auto;
    min-width: 0;
`

const Title = styled.div`
    ${text('label', 'primary', 'text')}
    white-space: nowrap;
    display: flex;
    flex: 0 1 auto;
    min-width: 0;
`
